import { useState } from 'react';
import PrivacyPolicyModal from '../../components/PrivacyPolicyModal/PrivacyPolicyModal';

import styles from './Login.module.css';

let BACKEND_URL = 'http://localhost:8000';

if (process.env.NODE_ENV === 'production') {
  BACKEND_URL = 'https://' + process.env.REACT_APP_HOST;
}

const Login = () => {
  const [isPrivacyPolicyModalOpen, setIsPrivacyPolicyModalOpen] = useState(false);

  const handleClosePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModalOpen(false);
  };

  const handleSignUpWithGoogle = () => {
    try {
      // redirect to Google sign-in page
      window.location.href = `${BACKEND_URL}/chat/google-oauth2/login/redirect/`;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.wrapper}>
      <video muted loop autoPlay playsInline className={styles.bgVideo}>
        <source src="/hgl-background.mp4" type="video/mp4" />
      </video>
      <div className={styles.loginContainer}>
        <div className={styles.loginContainerContent}>
          <h1>Welcome to</h1>
          <img src="/Hacker-GPT-KO.webp" alt="HackerGpt Lite" className={styles.logo} />
          <div className={styles.loginButtonWrapper}>
            <button
              className={styles.loginWithGoogleBtn}
              id="signupWithGoogle"
              onClick={handleSignUpWithGoogle}
            >
              Continue with Google
            </button>
          </div>

          <div className={styles.privacyPolicyButtonWrapper}>
            <button
              className={styles.privacyPolicyBtn}
              onClick={() => setIsPrivacyPolicyModalOpen(true)}
            >
              Privacy Policy
            </button>
          </div>
          
        </div>
      </div>

      <PrivacyPolicyModal isOpen={isPrivacyPolicyModalOpen} onClose={handleClosePrivacyPolicyModal} />
    </div>
  );
};

export default Login;
